import { createAction, props } from "@ngrx/store";

export const loginDetails = createAction(
    'loginDetails',
    props<{ logindata: {} }>()
)

export const otpVerifiedDetails = createAction(
    'otpVerifiedDetails',
    props<{ otpVerfiedData: {} }>()
)
export const userDetails = createAction(
    'userDeatails',
    props<{ data: any }>()
)

export const localLanguage = createAction(
    'localLanguage',
    props<{ language: any }>()
)

export const businessDetails = createAction(
    'businessDetails',
    props<{ data: any }>()
)
export const allApiLinks = createAction(
    'allApiLinks',
    props<{ data: any }>()
)

export const dashboardDetails = createAction(
    'dashboardDetails',
    props<{ dashboardDetails }>()
)
export const usersList = createAction(
    'usersList',
    props<{ users: any }>()
)

export const selectedUser = createAction(
    'selectedUser',
    props<{ selectedUser: any }>()
)

export const permissionData = createAction(
    'permissionData',
    props<{ permissionData: any }>()
)
export const tempararyAddUserFormData = createAction(
    'tempararyAddUserFormData',
    props<{ tempararyAddUserFormData: any }>()
)

export const clearReducer = createAction(
    'clearReducer',
)



